import { BRIEF_SOURCE, MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { Store } from '../types';

type BriefSourceState = ReturnType<typeof getBriefSource>;

const getQueryParams = () => {
    if (window) {
        return new URLSearchParams(window.location.search);
    }
    return null;
};

const getBriefSource = () => {
    const source = getQueryParams()?.get('source');
    const isFromMarketplace = source === 'marketplace';
    const value = isFromMarketplace ? BRIEF_SOURCE.MP_BRIEF : BRIEF_SOURCE.LM_BRIEF;

    return {
        [MIXPANEL_EVENT_PROPERTIES.BRIEF_SOURCE]: value,
    };
};

export class BriefSourceStore implements Store<BriefSourceState> {
    public getData = () => getBriefSource();
}
